<template>
  <div :key="item.cart_id || item.promo_id" class="py-4 border-b border-gray-200 flex items-center space-x-4">
    <img :src="item.image" :alt="item.title" class="w-16 h-16 rounded object-cover" />
    <div class="flex-1">
      <div class="text-sm font-semibold text-gray-800">{{ item.title }}</div>
      <div v-if="viewType === 'cart'">
        <div class="text-sm text-gray-600">จำนวน: {{ item.quantity }} ชิ้น</div>
        <div class="text-sm text-gray-600">
          ราคา {{ (item.quantity * item.selling_price).toLocaleString() }} บาท
        </div>
      </div>
      <div v-else-if="viewType === 'favorite'">
        <div class="text-sm text-gray-600">รายละเอียด: {{ item.subtitle }}</div>
        <div class="text-sm text-gray-600">ราคา {{ item.selling_price }} บาท</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    viewType: {
      type: String,
      required: true,
      validator: (value) => ["cart", "favorite"].includes(value),
    },
  },
};
</script>